import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemo2Ctx } from '../Demo2Context';
import { STATUS_COLOR, type AlertLevel } from '../demo2Data';

type LevelFilter = AlertLevel | 'all' | 'unread';
const LEVELS: { key: LevelFilter; label: string }[] = [
    { key: 'all', label: '전체' }, { key: 'unread', label: '미확인' },
    { key: 'danger', label: '심각' }, { key: 'warn', label: '위험' }, { key: 'caution', label: '주의' },
];

export default function Demo2Alerts() {
    const navigate = useNavigate();
    const { alerts, markAlertRead, markAllAlertsRead } = useDemo2Ctx();
    const [lvlFilter, setLvlFilter] = useState<LevelFilter>('all');

    const countFor = (k: LevelFilter) => {
        if (k === 'all') return alerts.length;
        if (k === 'unread') return alerts.filter(a => !a.read).length;
        return alerts.filter(a => a.level === k).length;
    };

    const list = alerts.filter(a => {
        if (lvlFilter === 'all') return true;
        if (lvlFilter === 'unread') return !a.read;
        return a.level === lvlFilter;
    });
    const unread = alerts.filter(a => !a.read).length;

    return (
        <div className="list-page">
            <div className="list-bar">
                <div className="chips">
                    {LEVELS.map(o => (
                        <div key={o.key} className={`chip${lvlFilter === o.key ? ' active' : ''}`} onClick={() => setLvlFilter(o.key)}>
                            {o.label}<span style={{ marginLeft: 4, fontSize: 10, fontWeight: 700, opacity: 0.7 }}>{countFor(o.key)}</span>
                        </div>
                    ))}
                </div>
                <div style={{ flex: 1 }} />
                <span className="text-xs text-muted">{list.length}건 표시 · 미확인 {unread}건</span>
                <button className="btn btn-secondary btn-sm" onClick={markAllAlertsRead}><i className="ri-check-double-line" /> 모두 읽음 처리</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px', maxWidth: 920 }}>
                {list.length === 0 && (
                    <div className="d2-empty">
                        <i className="ri-checkbox-circle-line" />
                        <div className="d2-empty-txt">조건에 해당하는 알림이 없습니다</div>
                    </div>
                )}
                {list.map((a, i) => {
                    const lvlLbl = a.level === 'danger' ? '심각' : a.level === 'warn' ? '위험' : '주의';
                    return (
                        <div key={a.id} className={`data-card fade-up d${i % 5}`} style={{ marginBottom: 12, ...(!a.read ? { borderLeft: `4px solid ${STATUS_COLOR[a.level]}` } : {}) }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 8 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                                    <span className={`badge badge-${a.level}`}>{lvlLbl}</span>
                                    {!a.read && <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--danger)', display: 'inline-block' }} />}
                                    <span style={{ fontSize: 13.5, fontWeight: 800 }}>{a.title}</span>
                                </div>
                                <span className="text-xs text-muted" style={{ whiteSpace: 'nowrap' }}>{a.time}</span>
                            </div>
                            <div style={{ fontSize: 12.5, color: 'var(--text2)', lineHeight: 1.65, marginBottom: 10 }}>{a.msg}</div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                                <span className="text-xs text-muted"><i className="ri-map-pin-line" /> {a.zoneName}</span>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    {!a.read && <button className="btn btn-ghost btn-sm" onClick={() => markAlertRead(a.id)}>읽음 처리</button>}
                                    <button className="btn btn-primary btn-sm" onClick={() => navigate('/demo2/web/work-management')}><i className="ri-drop-line" /> 작업지시 생성</button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
